import {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import mustBeLogged from '../../components/Must/MustBeLogged.jsx'
import StrategyFreelanceContainer from './StrategyFreelanceContainer.jsx'
import MyAccount from "./Containers/MyAccount/MyAccount.jsx"

import actions from '../../components/CurrentUserLoader/actions.js'
import conf from '../../../shared/conf.js'

class MyAccountContainer extends Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return nextProps.endLoadingCurrentUser
  }

  render() {
    const {currentUser, currentFreelance, endLoadingCurrentUser, ...rest} = this.props

    return (
      <StrategyFreelanceContainer
        currentUser={currentUser}
        isOwner={!!currentUser}
        loading={!endLoadingCurrentUser}
        navbar={true}
        profile={{user: currentUser, freelance: currentFreelance}}
        view={MyAccount}
        {...rest}
      />
    )
  }
}

export default connect(
  (state) => ({
    currentUser: state.currentUser.user,
    currentFreelance: state.currentUser.freelance,
    endLoadingCurrentUser: state.currentUser.endLoading,
  }),
  (dispatch) => bindActionCreators(actions, dispatch)
)(mustBeLogged(MyAccountContainer, conf.accountTypes.freelance))